import React, {useEffect} from "react";
import ReactGA from "react-ga";

export const LoadingView = () => {
    useEffect(() => {
        ReactGA.set({page: "/con/loading"});
        ReactGA.pageview("/con/loading");
    }, []);
    return (
        <div className="AppViews--view">
            <div className="AppViews--simple">
                Loading...
            </div>
        </div>
    );
};
